import { useContext, useState, useCallback, useEffect } from 'react';
import { CONVERSATION_CONSTANTS } from './src-config-miaw-constants.js';
import { MiawChatContext } from './src-contexts-MiawChatContext.js';
import { closeConversation } from './src-utils-miaw-api-utils.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';
import { CAContext } from './src-contexts-CAContext.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';
import { clearInMemoryData } from './src-utils-miaw-chat-config.js';
import { useMIAWAgentActions } from './src-hooks-miaw-useMIAWAgentActions.js';
import { clearPreChatInfoFromLocalStorage, clearIsUserLoggedInAtChatStart, clearChatbotToken, clearRestId, clearChatSessionType } from './src-utils-session-storage-utils.js';

const useMIAWChatEnd = () => {
  const { logCustomAttributesNR } = useNRLogging();
  const {
    state: { conversationId },
    setState: setMIAWContext
  } = useContext(MiawChatContext);
  const { setChatState } = useContext(CAContext);
  const { setState: setChatbotState } = useContext(ChatbotContext);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [toggle, setToggle] = useState(false);
  const { handleCloseEventSource } = useMIAWAgentActions();
  const trigger = useCallback(() => {
    clearPreChatInfoFromLocalStorage();
    setToggle((prev) => !prev);
  }, []);
  useEffect(() => {
    if (toggle) {
      setLoading(true);
      logCustomAttributesNR("ca-chatbot-miaw-api-request", {
        logLevel: "info",
        message: "Closing conversation",
        conversationId,
        apiType: "miawCloseConversation"
      });
      if (conversationId) {
        closeConversation(conversationId).then((res) => {
          setData(`Conversation CLosed ${conversationId}`);
          setError(void 0);
          setMIAWContext((prev) => ({ ...prev, conversationStatus: CONVERSATION_CONSTANTS.ConversationStatus.CLOSED_CONVERSATION }));
          logCustomAttributesNR("ca-chatbot-miaw-api-response", {
            logLevel: "info",
            message: "Conversation closed successfully",
            conversationId,
            apiType: "miawCloseConversation"
          });
        }).catch((error2) => {
          console.error(error2);
          setError(error2);
          logCustomAttributesNR("ca-chatbot-miaw-api-error", {
            errorName: error2.name,
            errorStack: error2.stack,
            message: error2.message,
            logLevel: "error",
            apiType: "miawCloseConversation"
          });
        }).finally(() => {
          setLoading(false);
          setToggle(false);
          handleCloseEventSource();
          setMIAWContext((prevState) => ({
            ...prevState,
            conversationMessages: [],
            conversationId: "",
            agentName: "",
            conversationStatus: CONVERSATION_CONSTANTS.ConversationStatus.NOT_STARTED_CONVERSATION
          }));
          clearInMemoryData();
          setChatbotState((prevState) => ({
            ...prevState,
            conversationMessages: [],
            discussionId: "",
            sessionId: ""
          }));
          clearIsUserLoggedInAtChatStart();
          clearChatbotToken();
          clearRestId();
          clearChatSessionType();
          setChatState((prevState) => ({
            ...prevState,
            // chatWindow: 'minimized',
            chatSession: "endChatSession",
            isPrivacyPolicyAccepted: false,
            unreadMessages: 0
          }));
        });
      } else {
        clearChatbotToken();
        clearChatSessionType();
        setLoading(false);
        setError(new Error("No conversationId found"));
        setData(void 0);
        setChatState((prevState) => ({
          ...prevState,
          // chatWindow: 'minimized',
          chatSession: "endChatSession",
          isPrivacyPolicyAccepted: false,
          unreadMessages: 0
        }));
      }
    }
  }, [toggle, conversationId]);
  return {
    loading,
    trigger,
    data,
    error
  };
};

export { useMIAWChatEnd };
//# sourceMappingURL=src-hooks-miaw-useMIAWChatEnd.js.map
